import { Link } from "react-router-dom";
import { Facebook, Twitter, Linkedin, Instagram, Phone, Mail, MapPin, Globe, Download } from "lucide-react";
import { useState } from "react";
import { SITE, SERVICES } from "../data/site";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Footer() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      await axios.post(`${API}/newsletter`, { email });
      setStatus("Subscribed!");
      setEmail("");
    } catch {
      setStatus("Something went wrong");
    }
    setTimeout(() => setStatus(""), 3000);
  };

  return (
    <footer data-testid="site-footer" className="bg-slate-950 text-slate-300">
      <div className="container-st py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <Link to="/" className="flex items-center gap-3">
            <img src={SITE.logo} alt="Amcblast Solutions Limited" className="h-12 w-auto object-contain bg-slate-900 rounded-xl p-1" />
          </Link>
          <p className="mt-5 text-sm leading-relaxed">
            <span className="font-semibold text-white">{SITE.tagline}</span> An indigenous
            dynamic IT solutions partner delivering software, networks, security, power and
            infrastructure across Africa and beyond.
          </p>
          <p className="text-xs text-slate-500 mt-3">{SITE.rc}</p>
          <div className="flex gap-3 mt-6">
            {[Facebook, Twitter, Linkedin, Instagram].map((Icon, i) => (
              <a
                key={i}
                href="#"
                data-testid={`social-${i}`}
                className="h-9 w-9 rounded-full bg-slate-800 grid place-items-center hover:bg-blue-600 transition"
              >
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
          <a
            href={SITE.profilePdf}
            target="_blank"
            rel="noreferrer"
            data-testid="footer-profile-pdf"
            className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-blue-400 hover:text-blue-300"
          >
            <Download className="w-4 h-4" /> Download Company Profile
          </a>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4">Services</h4>
          <ul className="space-y-2 text-sm">
            {SERVICES.slice(0, 8).map((s) => (
              <li key={s.slug}>
                <Link to={`/services/${s.slug}`} className="hover:text-blue-400 transition">
                  {s.title}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/services" className="font-semibold text-blue-400">All services →</Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4">Company</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-blue-400">About</Link></li>
            <li><Link to="/profile" className="hover:text-blue-400">Company Profile</Link></li>
            <li><Link to="/solutions" className="hover:text-blue-400">Solutions</Link></li>
            <li><Link to="/faq" className="hover:text-blue-400">Help / AmcBot</Link></li>
            <li><Link to="/contact" className="hover:text-blue-400">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4">Get in touch</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex gap-3"><Phone className="w-4 h-4 mt-0.5 text-blue-400 shrink-0" /><span>{SITE.phone}</span></li>
            <li className="flex gap-3 items-center">
              <span className="text-green-400 text-base shrink-0">💬</span>
              <a href="https://wa.me/2348113748129" target="_blank" rel="noreferrer" className="text-green-400 hover:text-green-300 font-semibold transition">WhatsApp: +234 811 374 8129</a>
            </li>
            <li className="flex gap-3"><Mail className="w-4 h-4 mt-0.5 text-blue-400 shrink-0" /><span>{SITE.email}</span></li>
            <li className="flex gap-3"><Globe className="w-4 h-4 mt-0.5 text-blue-400 shrink-0" /><span>{SITE.website}</span></li>
            {SITE.offices.map((o) => (
              <li key={o.label} className="flex gap-3">
                <MapPin className="w-4 h-4 mt-0.5 text-blue-400 shrink-0" />
                <span><span className="text-white font-semibold">{o.label}:</span> {o.line}</span>
              </li>
            ))}
          </ul>
          <form onSubmit={subscribe} className="mt-5 flex gap-2" data-testid="newsletter-form">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Your email"
              data-testid="newsletter-input"
              className="flex-1 px-4 py-2 rounded-full bg-slate-800 border border-slate-700 text-sm placeholder:text-slate-500 focus:outline-none focus:border-blue-500"
            />
            <button
              type="submit"
              data-testid="newsletter-submit"
              className="px-4 py-2 rounded-full bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold"
            >
              Join
            </button>
          </form>
          {status && <p data-testid="newsletter-status" className="text-xs text-blue-400 mt-2">{status}</p>}
        </div>
      </div>
      <div className="border-t border-slate-800">
        <div className="container-st py-6 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-slate-500">
          <p>© {new Date().getFullYear()} {SITE.company}. All rights reserved.</p>
          <p>Designed and managed by Amcblast in-house team.</p>
        </div>
      </div>
    </footer>
  );
}
